export const messages = {
  en: {
    aStaffCommunity: {
      orgPlaceholder: 'Select organization',
      staffPlaceholder: 'Enter staff name',
      linkCommunity: 'Link Community',
      staffName: 'Staff Name',
      staffId: 'Staff ID',
      communityId: 'Community ID',
      communityName: 'Community Name',
      selectStaffFirst: 'Please select a staff first'
    }
  },
  zh: {
    aStaffCommunity: {
      orgPlaceholder: '选择组织',
      staffPlaceholder: '填写员工名称',
      linkCommunity: '关联小区',
      staffName: '员工名称',
      staffId: '员工编号',
      communityId: '小区编号',
      communityName: '小区名称',
      selectStaffFirst: '请先选择员工'
    }
  }
}